
export const authForceRefreshCookieName = "auth_force_refresh";
